jQuery(document).ready(function($) {
	/**
	 * Function to extract number and surrounding text
	 */
	function parseStatContent( content ) {
		// Match pattern: optional prefix, number (with optional decimal), optional suffix
		const regex = /^([^0-9]*)([0-9]+\.?[0-9]*)(.*)$/;
		const match = content.match( regex );

		if ( ! match ) {
			return { prefix: '', number: null, suffix: '', decimals: 0 };
		}

		const prefix = match[ 1 ];
		const numberStr = match[ 2 ];
		const suffix = match[ 3 ];
		const number = parseFloat( numberStr );
		const decimals = numberStr.includes( '.' ) ? numberStr.split( '.' )[ 1 ].length : 0;

		return { prefix, number, suffix, decimals };
	}

	/**
	 * Animate the counter from 0 to target value
	 */
	function animateCounter( $element, parsed, duration ) {
		const obj = { value: 0 };

		gsap.to( obj, {
			value: parsed.number,
			duration: duration,
			ease: 'power2.out',
			onUpdate: function() {
				const currentValue = obj.value.toFixed( parsed.decimals );
				$element.text( parsed.prefix + currentValue + parsed.suffix );
			}
		} );
	}

	/**
	 * Initialize animated stats
	 */
	function initAnimatedStats() {
		if ( typeof gsap === 'undefined' ) {
			setTimeout( initAnimatedStats, 100 );
			return;
		}

		// Get all stat items
		const $statItems = $( '.wp-block-jormi-stat-item__content' );

		if ($statItems.length === 0 ) return;

		$statItems.each( function() {
			const $item = $( this );
			const originalContent = $item.attr( 'data-stat-content' ) || $item.text();
			const duration = parseFloat( $item.attr( 'data-animation-duration' ) ) || 2;
			
			// Parse the content to extract number and surrounding text
			const parsed = parseStatContent( originalContent );
			
			if ( parsed.number === null ) {
				return; // No number found, skip
			}

			// Set initial state to 0
			$item.text( parsed.prefix + '0' + parsed.suffix );

			// Create new observer to trigger animation when element comes into view
			const observer = new IntersectionObserver(
				( entries ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							animateCounter( $item, parsed, duration );
							observer.unobserve( entry.target ); // Animate once
						}
					} );
				},
				{ threshold: 0.5 }
			);

			observer.observe( $item[ 0 ] );
		} );
	}

	// Init call
	initAnimatedStats();
});